import { render } from "./OrganizationInfor.vue?vue&type=template&id=68fbed20"
import script from "./OrganizationInfor.vue?vue&type=script&lang=js"
export * from "./OrganizationInfor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__